import React from "react";
import Container from "./Container";



function Home(){
    
    return (<>
        
        <Container/>
    
        
    </>)
}
export default Home;